import * as api from '../api';
import { WebRequest, WebRequestStatus, BaseOrganization } from '../models';
import {
  defineModule,
  localActionContext
  // localGetterContext
} from 'direct-vuex';

const getInitialState = (): WebRequest<BaseOrganization[]> => {
  return {
    data: null,
    status: WebRequestStatus.READY
  };
};

// const authGetterContext = (args: [any, any, any, any]) =>
// localGetterContext(args, auth);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const orgsActionContext = (context: any) =>
  // eslint-disable-next-line  @typescript-eslint/no-use-before-define
  localActionContext(context, organizations);

const organizations = defineModule({
  namespaced: true as true,
  state: getInitialState(),
  getters: {},
  mutations: {
    startProgress: state => {
      state.status = WebRequestStatus.IN_PROGRESS;
    },
    fail: state => {
      state.status = WebRequestStatus.FAILURE;
    },
    reset: state => {
      state.status = WebRequestStatus.READY;
    },
    succeed: (state, data: BaseOrganization[]) => {
      state.status = WebRequestStatus.SUCCESS;
      state.data = data;
    }
  },
  actions: {
    fetch: async context => {
      const { commit } = orgsActionContext(context);

      commit.startProgress();

      try {
        const orgs = await api.secure.getUserOrganizations();
        commit.succeed(orgs);
      } catch (error) {
        console.error(error);
        commit.fail();
      }
    }
  }
});

export default organizations;
